module.exports = __webpack_public_path__ + "static/media/info.313b274e.svg";